module.exports = __webpack_public_path__ + "img/emptyness.f8cf8b31.svg";